import { styled } from "styled-components";

export const StyledLightBox = styled.dialog`
    border: unset;
    border-radius: 0.25rem;
    box-shadow: 0 0 28px 0 rgba(0 0 0 / 25%);
    padding: 0;

    ::backdrop {
        background-color: var(--color-white-o90, rgba(255 255 255 / 90%));
    }
`;

export const ButtonContainer = styled.div`
    align-items: flex-start;
    align-self: stretch;
    border-bottom: 1px solid var(--line-on-neutral-default);
    display: flex;
    gap: 0.625rem;
    justify-content: flex-end;
    padding: 0.875rem;

    button {
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 0.4375rem;
    }
`;

export const ImageContainer = styled.div`
    gap: 0.625rem;
    padding: 0.875rem;

    img {
        height: auto;
        max-height: calc(100vh - 9.1875rem);
        max-width: calc(100vw - 5rem);
        width: auto;
    }
`;
